import {IndexRedirect, Route} from 'react-router';
import React from 'react';

import checkFeatureFlagStatusOnEnter from 'client/Routing/checkFeatureFlagStatusOnEnter';
import sessionStore from 'client/Session/SessionStore';
import StudentHomepage from './StudentHomepage';
import {StudentIndependentPractice} from './StudentIndependentPractice/StudentIndependentPractice';
import StudentHomepageAssignmentsTabContent from './StudentAssignments/StudentAssignments';
import {StudentSkillPath} from './StudentSkillPath/StudentSkillPath';
import {clearSkillPathCache} from './StudentSkillPath/useStudentSkillPath';

const StudentHomepageRoutes = (
  <Route
    component={StudentHomepage}
    onEnter={(nextState, replace, callback) => {
      if (sessionStore.hasValidSession() && !sessionStore.isStudent()) {
        replace('/classes');
        callback?.();
        return;
      } else {
        return checkFeatureFlagStatusOnEnter('new_student_dashboard', '/classes', 'require')(
          nextState,
          replace,
          callback
        );
      }
    }}
    onLeave={clearSkillPathCache}
    path='home'
  >
    <IndexRedirect to='assignments' />
    <Route
      path='(class/:classroomId/)assignments'
      component={StudentHomepageAssignmentsTabContent}
    />
    <Route path='(class/:classroomId/)skill-path' component={StudentSkillPath} />
    <Route
      path='(class/:classroomId/)independent-practice'
      component={StudentIndependentPractice}
    />
  </Route>
);

export default StudentHomepageRoutes;
